import React from "react";
import Text from "../../../shared/components/Text";

export const FILE_TYPE = {
  bank_account_ownership_documentation: (
    <Text tId="BANK_ACCOUNT_OWNERSHIP_DOCUMENTATION" />
  ),
  payroll: <Text tId="PAYROLL" />,
  personal_income_tax: <Text tId="PERSONAL_INCOME_TAX" />,
  biometrics_document: <Text tId="BIOMETRICS_DOCUMENT" />,
  document_id_front: <Text tId="DOCUMENT_ID_FRONT" />,
  document_id_back: <Text tId="DOCUMENT_ID_BACK" />,
  enrollment_of_the_student: <Text tId="ENROLLMENT_OF_THE_STUDENT" />,
};

export const mimeTypes = {
  IMAGE: /image\/.+/g,
  PDF: /application\/pdf/g,
};

export const documentStatus = {
  PENDING: "pending",
  UPLOADED: "uploaded",
  INCIDENCE: "incidence",
  VALIDATED: "validated",
};
